module.exports = __webpack_public_path__ + "assets/img/sleep.39a55580.png";